import React from 'react';
import {PopperProps} from '@mui/material';
import {ContextMenuContext} from './ContextMenuContext';

export function useBuildContextMenu<T>() {
   const [data, setData] = React.useState<T>();
   const [anchorEl, setAnchorEl] = React.useState<PopperProps['anchorEl']>(null);

   const handleClick = React.useCallback(
      (data: T) => (event: React.MouseEvent<HTMLElement>) => {
         event.preventDefault();
         event.stopPropagation();
         event.nativeEvent.stopImmediatePropagation();

         const rect = event.currentTarget.getBoundingClientRect();
         // console.debug('handleClick', event, rect);
         const newRect = {
            top: event.clientY,
            bottom: event.clientY + 1,
            left: event.clientX,
            right: event.clientX + 1,
            y: event.clientY,
            x: event.clientX,
            height: 1,
            width: 1,
            toJSON: () => JSON.stringify(newRect),
         };

         // console.debug(rect, newRect);
         setAnchorEl({
            // clientHeight: rect.height,
            // clientWidth: rect.width,
            getBoundingClientRect: () => newRect,
         });
         setData(data);
         return false;
      },
      [setAnchorEl]
   );

   const handleClose = React.useCallback(
      (ev?: React.MouseEvent<HTMLElement>) => {
         // console.debug('handleClose', ev);
         setAnchorEl(null);
      },
      [setAnchorEl]
   );

   const contextValue = React.useMemo(
      () =>
         ({
            data,
            anchorEl,
            handleClose,
            handleClick,
         } as ContextMenuContext<T>),
      [data, anchorEl, handleClose, handleClick]
   );

   return {
      contextValue,
   };
}
